module.exports = __webpack_public_path__ + "static/pemalex_logo_clientes_thaysethamires-513aac51de8fada1d35b5ce665edad4c.png";